<div class="confirm-banner"></div>
<div class="body-container mx-auto">
  <header style="margin-bottom: 0.75rem;">
    <h1 class="page-title text-center">
      Hooray! You're All Set!
    </h1>
  </header>
  <p class="page-subtitle text-center">
    Thanks for creating your account with Camp Bow Wow<sup>&#174;</sup>. Please take a moment to complete your profile
    and a profile for your pup(s).
  </p>
  <div
    class="action-container"
    style="margin-top: 4rem;"
  >
    <button
      class="btn btn-danger btn-block"
      (click)="navigateToLandingPage()"
    >Let's Go!</button>
  </div>
</div>
